import { Flex } from '@m/alchemy-ui/Flex';
import { Text } from '@m/alchemy-ui/Text';
import { EmployeeBadgeType } from 'achievements/constants';
import { dateMonthYearFormat, DateTime } from 'common/utils/date';
import * as Styled from './Styled';
import { ArrowNextIcon } from '@m/alchemy-ui/icons/ArrowNextIcon';
import { Link } from '@m/alchemy-ui/Link';

const RecentAchievements = ({ badges }: { badges?: EmployeeBadgeType[] }) => {
  return (
    <Styled.NotificationsContainer>
      <Text typeStyle="subHeaderS" color="typeHeader">
        Recently earned badges
      </Text>
      <Flex direction="column" gap={12} alignItems="flex-start">
        {badges?.map(badge => {
          const {
            badgeKey,
            name,
            earnedAt,
            iconSettings,
            companyAchievement: { pathName },
          } = badge;
          return (
            <div key={badgeKey}>
              <Styled.Date>{DateTime.fromISO(earnedAt).toFormat(dateMonthYearFormat)}</Styled.Date>
              <div>
                You earned <span className="font-weight-xlarge">{name}</span> badge
                {pathName && iconSettings?.label && `, ${iconSettings?.label} in The ${pathName}!`}
              </div>
            </div>
          );
        })}
        {badges && badges.length === 0 && (
          <Text typeStyle="bodyS" color="typeMeta">
            Check back here to see your most recently earned badges!
          </Text>
        )}
      </Flex>
      <Link
        target="_blank"
        rel="noopener noreferrer"
        href={'/achievements'}
        className="margin-left-auto"
      >
        <Styled.LinkText>
          See achievements
          <ArrowNextIcon size={14} aria-hidden className="align-self-end margin-left-small" />
        </Styled.LinkText>
      </Link>
    </Styled.NotificationsContainer>
  );
};

export default RecentAchievements;
